module.exports = __webpack_public_path__ + "media/copy.10502537.svg";